export const COLORS = {
    ALLERGEN_BACKGROUND : [
        'rgba(255, 99, 132, 0.8)',
        'rgba(54, 162, 235, 0.8)',
        'rgba(255, 206, 86, 0.8)',
        'rgba(75, 192, 192, 0.8)',
        'rgba(153, 102, 255, 0.8)',
        'rgba(255, 159, 64, 0.8)',
        'rgba(255, 99, 132, 0.8)',
        'rgba(54, 162, 235, 0.8)',
        'rgba(255, 206, 86, 0.8)',
        'rgba(75, 192, 192, 0.8)',
        'rgba(153, 102, 255, 0.8)',
        'rgba(255, 159, 64, 0.8)',
        'rgba(255, 99, 132, 0.8)',
        'rgba(54, 162, 235, 0.8)',
        'rgba(255, 206, 86, 0.8)',
        'rgba(75, 192, 192, 0.8)',
        'rgba(153, 102, 255, 0.8)',
        'rgba(255, 159, 64, 0.8)',
        'rgba(255, 99, 132, 0.8)',
        'rgba(54, 162, 235, 0.8)',
        'rgba(255, 206, 86, 0.8)',
        'rgba(75, 192, 192, 0.8)',
        'rgba(153, 102, 255, 0.8)',
        'rgba(255, 159, 64, 0.8)',
        'rgba(255, 99, 132, 0.8)',
        'rgba(54, 162, 235, 0.8)',
        'rgba(255, 206, 86, 0.8)',
        'rgba(75, 192, 192, 0.8)'
    ],
    ALLERGEN_BORDER : [
        'rgba(255,255,255,1)',
        'rgba(255, 255, 255, 1)',
        'rgba(255, 255, 255, 1)',
        'rgba(255, 255, 255, 1)',
        'rgba(255, 255, 255, 1)',
        'rgba(255, 255, 255, 1)',
        'rgba(255,255,255,1)',
        'rgba(255, 255, 255, 1)',
        'rgba(255, 255, 255, 1)',
        'rgba(255, 255, 255, 1)',
        'rgba(255, 255, 255, 1)',
        'rgba(255, 255, 255, 1)',
        'rgba(255,255,255,1)',
        'rgba(255, 255, 255, 1)',
        'rgba(255, 255, 255, 1)',
        'rgba(255, 255, 255, 1)',
        'rgba(255, 255, 255, 1)',
        'rgba(255, 255, 255, 1)',
        'rgba(255,255,255,1)',
        'rgba(255, 255, 255, 1)',
        'rgba(255, 255, 255, 1)',
        'rgba(255, 255, 255, 1)',
        'rgba(255, 255, 255, 1)',
        'rgba(255, 255, 255, 1)',
        'rgba(255,255,255,1)',
        'rgba(255, 255, 255, 1)',
        'rgba(255, 255, 255, 1)',
        'rgba(255, 255, 255, 1)',        
    ],
    DIET_BACKGROUND: [
        'rgba(255, 99, 132, 0.65)',
        'rgba(54, 162, 235, 0.65)',
        'rgba(255, 206, 86, 0.65)',
        'rgba(75, 192, 192, 0.65)',
        'rgba(153, 102, 255, 0.65)',
        'rgba(255, 159, 64, 0.65)'
    ],
    DIET_BORDER: [
        'rgba(255,255,255,0.4)',
        'rgba(255, 255, 255, 0.4)',
        'rgba(255, 255, 255, 0.4)',
        'rgba(255, 255, 255, 0.4)',
        'rgba(255, 255, 255, 0.4)',
        'rgba(255, 255, 255, 0.4)'        
    ],
    AUDIT_BACKGROUND : [
        'rgba(153, 102, 255, 0.65)',        
        'rgba(255, 159, 64, 0.65)',
        'rgba(54, 162, 235, 0.65)',
        'rgba(75, 192, 192, 0.65)', 
        'rgba(255, 206, 86, 0.65)',
        'rgba(255, 99, 132, 0.65)',           
    ],
    AUDIT_BORDER : [
        'rgba(255, 255, 255, 0.4)',
        'rgba(255, 255, 255, 0.4)',        
        'rgba(255, 255, 255, 0.4)',
        'rgba(255, 255, 255, 0.4)',        
        'rgba(255, 255, 255, 0.4)',
        'rgba(255,255,255,0.4)',          
    ],
}

export const ID_ENUMS = {
    WEEKLY_ID  : 0,
    MONTHLY_ID : 1,
    YEARLY_ID  : 2,
    CLICKS_POPOVER_ID : 3,
    DIET_POPOVER_ID : 4,
    ALLERGEN_POPOVER_ID : 5,
    AUDIT_POPOVER_ID : 6 
}

export const SAMPLE_DATA = {
    DIET_LABELS: ["Vegetarian", "Vegan", "Gluten-Free", "Paleo", "KETO", "FODMAP"],
    DIET_DATA: [10,8,9,3,5,2],
    ALLERGEN_LABELS: ["Beef", "OtherReadMeat", "WhiteMeat", "Pork", "Fish", "HighSugar", "Cheese", "ShellFish", "Rice", "Eggs", "Mushroom","Peanuts", "Treenuts"],
    ALLERGEN_DATA: [12,12,10,10,10,5,7,10,2,4,,3,15,10]
}


export const DIET_IMAGES = {
    "Keto": "img/diets/keto_diet.png",
    "Vegan": "img/diets/vegan_diet.png",
    "Vegetarian": "img/diets/vegetarian_diet.png",
    "Paleo": "img/diets/paleo_diet.png",
    "Fodmap": "img/diets/fodmap_diet.png",
    "Gluten-Free": "img/diets/gf_diet.png"
}

export const ALLERGEN_IMAGES = {
    "Beef": "img/allergen/beef_allergen.png",
    "ReadMeat": "img/allergen/redmeat_allergen.png",
    "WhiteMeat": "img/allergen/whitemeat_allergen.png",
    "Pork": "img/allergen/pork_allergen.png",
    "Fish": "img/allergen/fish_allergen.png",
    "OtherSeafood": "img/allergen/seafood_allergen.png",
    "Tofu": "img/allergen/tofu_allergen.png",
    "HighSugar": "img/allergen/highsugar_allergen.png",
    "Garlic": "img/allergen/garlic_allergen.png",
    "Nightshades": "img/allergen/nightshade_allergen.png",
    "Potato": "img/allergen/potato_allergen.png",
    "Rice": "img/allergen/rice_allergen.png",
    "Peanuts": "img/allergen/peanuts_allergen.png",
    "Treenuts": "img/allergen/treenuts_allergen.png",
    "Dairy": "img/allergen/dairy_allergen.png",
    "Cheese": "img/allergen/cheese_allergen.png",
    "Eggs": "img/allergen/eggs_allergen.png",
    "Wheat": "img/allergen/gluten_allergen.png",
    "Gluten": "img/allergen/gluten_allergen.png",
    "Soy": "img/allergen/soy_allergen.png",
    "Sesame": "img/allergen/sesame_allergen.png",
    "Fruit": "img/allergen/fruit_allergen.png",
    "ShellFish": "img/allergen/shellfish_allergen.png",
    "Corn": "img/allergen/corn_allergen.png",
    "Honey": "img/allergen/honey_allergen.png",
    "SpicyFood": "img/allergen/spicyfood_allergen.png",
    "Mushrooms": "img/allergen/mushroom_allergen.png",
    "Onions": "img/allergen/onions_allergen.png",
    "Legumes": "img/allergen/legumes_allergen.png",
    
}

//Lookup of minor sections
export const MINOR_SECTIONS = {
    "sauces": 1,
    "appetizers": 1,
    "soups & salad": 1,
    "house sauces": 1,
    "soup": 1,
    "dessert": 1,
    "salads": 1,
    "insalata": 1,
}

export const NO_LOCATION_TEXT = " NONE: Select or Add a Location!"


// WEBPACK FOOTER //
// ./src/views/Analytics/constants.js